import {OrderRepository} from '@domain/model/Order/OrderRepository';

const CancelOrder =
  (orderRepository: OrderRepository): (() => Promise<Record<string, boolean>>) =>
  (): Promise<Record<string, boolean>> => {
    return orderRepository.cancelOrder();
  };

export {CancelOrder};
